import { AccountKYCStatusEnum } from '@/enums'

export const AccountKYCStatusData = {
  [AccountKYCStatusEnum.AML_VERIFIED]: {
    label: `accountKYCOptions.${AccountKYCStatusEnum.AML_VERIFIED}`,
    color: 'blue',
  },
  [AccountKYCStatusEnum.FAILED]: {
    label: `accountKYCOptions.${AccountKYCStatusEnum.FAILED}`,
    color: 'red',
  },
  [AccountKYCStatusEnum.KYC_VERIFIED]: {
    label: `accountKYCOptions.${AccountKYCStatusEnum.KYC_VERIFIED}`,
    color: 'green',
  },
  [AccountKYCStatusEnum.UNVERIFIED]: {
    label: `accountKYCOptions.${AccountKYCStatusEnum.UNVERIFIED}`,
    color: 'gray',
  },
}
